// MA-1044 — carry a readiness-check token from /onboarding?check=<token>
// across sign-up to the onboarding check-in step.
//
// Captured once at app start (main.jsx), before the gate ladder can render a
// sign-in screen and drop the query string. localStorage (top-level, first
// party — the trial link always opens at the top level, never in the
// site's frame), so a magic link opened in another tab of the same browser
// still finds it. The token holds no name, email or answer; it expires in 30
// days and the server re-verifies it before use. Storage is injectable for
// tests.
export const PENDING_CHECK_TOKEN_KEY = "pw_pending_check_token";
const SHAPE = /^pwc1\.[A-Za-z0-9_-]{1,500}\.[A-Za-z0-9_-]{20,100}$/;

function store(s?: Storage): Storage | undefined {
  if (s) return s;
  try {
    return typeof localStorage === "undefined" ? undefined : localStorage;
  } catch {
    return undefined;
  }
}

export function isCheckTokenShape(t: unknown): t is string {
  return typeof t === "string" && SHAPE.test(t);
}

/** Store the `check` query value when the URL is /onboarding with one. */
export function capturePendingCheckToken(loc: { pathname: string; search: string }, s?: Storage): boolean {
  if (!loc.pathname.startsWith("/onboarding")) return false;
  const t = new URLSearchParams(loc.search).get("check");
  if (!isCheckTokenShape(t)) return false;
  try {
    store(s)?.setItem(PENDING_CHECK_TOKEN_KEY, t);
    return true;
  } catch {
    return false;
  }
}

export function readPendingCheckToken(s?: Storage): string | null {
  try {
    const t = store(s)?.getItem(PENDING_CHECK_TOKEN_KEY) ?? null;
    return isCheckTokenShape(t) ? t : null;
  } catch {
    return null;
  }
}

export function clearPendingCheckToken(s?: Storage): void {
  try {
    store(s)?.removeItem(PENDING_CHECK_TOKEN_KEY);
  } catch {
    /* ignore */
  }
}
